import RouteCard from "./RouteCard";
import { useState, useEffect } from "react";
import { getRoutes } from "../getRoutes";


import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css/navigation";
import "swiper/css";

const Routes = ({i18n, text, lang}) => {
    const [routes, setRoutes] = useState([])

    useEffect(() => {
      getRoutes().then(setRoutes)
    }, [])
    const [activeRoute, setActiveRoute] = useState(null);
    return(
        <div className='block_5' id='routes'>
          <h3>{text["title_5"][lang]}</h3>
          <h6>{text["subtitle_5"][lang]}</h6>
          {activeRoute && (
            <div className="modal" onClick={() => setActiveRoute(null)}>
              <div className="modal_content" onClick={(e) => e.stopPropagation()}>
                <span onClick={() => setActiveRoute(null)}>x</span>
                <h1>{activeRoute.name[lang]}</h1>
                  {activeRoute.sections.map((info_img, i) => (
                      <div key={i}>
                        <img src={`${info_img.img}`} className="img" alt="route_img" />
                        <div>{info_img.text?.[lang]}</div>
                      </div>
                  ))}
              </div>

            </div>
          )}
          <div>
          <Swiper
            modules={[Pagination]}
            navigation={true}
            autoplay={false}
            pagination={{
                clickable: true,
            }}
            spaceBetween={20}
            slidesPerView={1}
            slidesPerGroup={1}>
              {routes.map(route => (
                <SwiperSlide key={route.img}>
                  <RouteCard i18n={i18n} desc={route.description} img={route.img} name={route.name} kms={route.kms} hours={route.hours} tempo={route.tempo} mountain={route.mountain} info={route.info} onClick={() => setActiveRoute(route)}/>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </div>
    )
}



export default Routes;